<script>
import { mapGetters } from 'vuex'

export default {
    name: "experienciaProfesionalPostulacion",
    data(){
        return {
            baseInformacionFamiliar: {
                parentescoId: null,
                nombres: null,
                apellidos: null,
                fechaNacimiento: null,
                numeroDeIdentificacion: null,
                tipoDocumentoId: null,
                ocupacion: null,
                paisId: null,
                departamentoId: null,
                municipioId: null,
            },
            departamentos: [],
            municipios: []

        }
    },
    mounted() {
        if( !this.$store.getters.resumenInformacionFamiliar.length ) {
            this.agregarRegistro()
        }
    },
    computed: {
        ...mapGetters({
            listaPaises: 'getPaises',
            listaDepartamentos: 'getDepartamentos',
            listaMunicipios: 'getMunicipios',
            parentescos: 'getParentescos',
            listaTipoDocumento: 'getTiposDeDocumentos',
            resumenInformacionFamiliar: 'resumenInformacionFamiliar'
        })
    },
    methods: {
        assertData(idx) {
            console.log(this.$store.getters.resumenInformacionFamiliar[idx]);
        },
        agregarRegistro() {
            this.$store.commit('appendElement', { key: 'resumenInformacionFamiliar', newElement: this.baseInformacionFamiliar} )
        },
        eliminarRegistro(idx) {
            this.departamentos.splice(idx, 1)
            this.municipios.splice(idx, 1)
            this.$store.commit('deleteElementAt', { key: 'resumenInformacionFamiliar', idx})
        },
        saveAndContinue() {
            const inputs = document.querySelectorAll('input, select')
            try {
                inputs.forEach(input => {
                    if (!input.checkValidity()) {
                        input.reportValidity()
                        throw new Error('Formulario incompleto')
                    }
                })
                
                

                let data = [
                    ...this.resumenInformacionFamiliar.map( formacion => {
                        formacion.PostulacionId = this.$store.getters.postulacionId
                        return formacion
                    })
                ]


                this.$store.getters.fetchPost({ path: 'Postulacion/InformacionFamiliar', data })
                .then( response => {
                    if( response.ok )
                    {
                        return response.json()
                    }
                    throw new Error("No se ha podido guardar educación formal")
                })
                .then( result => {
                    console.log(result);
                    this.$emit('nextStep')
                })
                .catch( error => console.log(error))



            } catch (error) {
                console.log(error);
                return
            }
        },
        setDepartamentosInElement( idx, paisId = null){
            this.$store.getters.fetchGet({ path: 'DepartamentoPais/ListByPais/' + paisId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.departamentos.length - 1) {
                        this.departamentos.push(data)
                    } else {
                        this.departamentos[idx] = data
                    }
                    this.departamentos = [...this.departamentos]
                })
                .catch(error => console.error(error))
        },
        setMunicipiosInElement( idx, departamentoId = null){
            this.$store.getters.fetchGet({ path: 'Municipio/ListByDepartamento/' + departamentoId })
            .then(response => {
                    if(response.ok){
                        return response.json()
                    }
                    throw new Error(response.status)
                })
                .then( data => {
                    if( idx > this.municipios.length - 1) {
                        this.municipios.push(data)
                    } else {
                        this.municipios[idx] = data
                    }
                    this.municipios = [...this.municipios]
                })
                .catch(error => console.error(error))
        }

        
    }
}

</script>
<template>
    <div>
        <b-form @submit.prevent="assertData(idx)" v-for="(familiar, idx) in resumenInformacionFamiliar" :key="'experiencia ' + idx">
            <b-row class="pb-1 px-3">
                <div class="d-flex align-items-center justify-content-between" style="width: 100%">
                    <p class="text-center my-0">
                        <b>
                            Ref. Familiar {{ idx + 1 }}
                        </b>
                    </p>
                    <div class="pointer btn btn-outline-danger m-1" @click="eliminarRegistro(idx)">
                        <i class="fas fa-solid fa-trash px-1"></i>Eliminar
                    </div>
                </div>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="informacionFamiliarParentesco" class="form-label">Parentesco</label>
                    <b-form-select required v-model="familiar.parentescoId" text-field="description" value-field="id"
                        :options="parentescos">
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm>
                    <label for="informacionFamiliarNombres" class="form-label">Nombres</label>
                    <b-form-input v-model="familiar.nombres" type="text" id="informacionFamiliarNombres" />
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="informacionFamiliarApellidos" class="form-label">Apellidos</label>
                    <b-form-input v-model="familiar.apellidos" type="text" id="informacionFamiliarApellidos" />
                </b-col>
                <b-col sm>
                    <label for="informacionFamiliarFechaNacimiento" class="form-label">Fecha de nacimiento</label>
                    <b-form-input v-model="familiar.fechaNacimiento" type="date" id="informacionFamiliarFechaNacimiento" />
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-col sm>
                    <label for="informacionFamiliarNumeroIdentificacion" class="form-label">Número de identificación</label>
                    <b-form-input v-model="familiar.numeroDeIdentificacion" type="number" id="informacionFamiliarNumeroIdentificacion" />
                </b-col>
                <b-col sm>
                    <label for="informacionFamiliarTipoIdentificacion" class="form-label">Tipo de identificación</label>
                    <b-form-select required v-model="familiar.tipoDocumentoId" text-field="descripcion" value-field="id"
                        :options="listaTipoDocumento">
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            
            <b-row class="pb-2">
                <b-col sm>
                    <label for="informacionFamiliarOcupacion" class="form-label">Ocupación</label>
                    <b-form-input v-model="familiar.ocupacion" type="text" id="informacionFamiliarOcupacion" />
                </b-col>
                <b-col sm>
                    <label for="educacionPais" class="form-label">País</label>
                    <b-form-select required v-model="familiar.paisId" text-field="descripcion" value-field="id"
                        :options="listaPaises"
                        @change.native="setDepartamentosInElement( idx, familiar.paisId)"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col sm>
                    <label for="educacionDepartamento" class="form-label">Departamento</label>
                    <b-form-select required v-model="familiar.departamentoId" text-field="descripcion" value-field="id"
                        :options="departamentos[idx]"
                        @change.native="setMunicipiosInElement( idx, familiar.departamentoId)"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm>
                    <label for="educacionMunicipio" class="form-label">Municipio</label>
                    <b-form-select required v-model="familiar.municipioId" text-field="descripcion" value-field="id"
                        :options="municipios[idx]"
                        >
                        <template #first>
                            <b-form-select-option selected :value="null" disabled>
                                Seleccionar
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
        </b-form>
        <div class="d-flex flex-row-reverse py-2" style="width: 100%; gap: 5px">
            <button class="btn px-4 py-2 btn-primary " @click="saveAndContinue">
                <span> Guardar y continuar </span>
            </button>
            <button class="btn px-4 py-2 btn-outline-success" @click="agregarRegistro">
                <span> Nuevo registro </span>
            </button>
        </div>
    </div>
</template>
